import { AccordionDetails, AccordionSummary, Divider, Theme, styled } from '@material-ui/core';
import { Accordion } from '../../../../../shared/components';

export const StyledDivider = styled(Divider)<Theme>(({ theme }) => ({
  flex: '0 0 100%',
  margin: theme.spacing(4, 0),
}));

export const StyledQuestionTitle = styled('div')<Theme>(({ theme }) => ({
  flex: '0 0 100%',
  marginBottom: theme.spacing(2),

  '& p': {
    margin: 0,
  },
}));

export const TopLevelQuestionType = styled('div')<Theme>(({ theme }) => ({
  fontFamily: theme.config.secondaryFontFamily,
  fontSize: theme.typography.bodyMd.fontSize,
  textTransform: 'uppercase',
  color: theme.palette.grey['600'],
  marginBottom: theme.spacing(2),
}));

export const StyledAccordion = styled(Accordion)({
  boxShadow: 'none',
  '&.Mui-expanded': {
    margin: 0,
  },
});

export const StyledAccordionSummary = styled(AccordionSummary)({
  padding: 0,
  '&.Mui-expanded': {
    minHeight: '4.8rem',
  },
  '& .MuiAccordionSummary-content': {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '0 !important',
    '&.Mui-expanded': {
      margin: 0,
    },
  },
});

export const StyledAccordionDetails = styled(AccordionDetails)({
  flexWrap: 'wrap',
});

export const AttemptLabel = styled('div')<Theme>(({ theme }) => ({
  fontWeight: 600,
  flexBasis: '55%',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1)
}));

export const TypeTreeDivider = styled('span')<Theme>(({ theme }) => ({
  padding: theme.spacing(0, 1),
}));
